const HSL_LIMITS = {
  h: {
    min: 0,
    max: 360
  },
  s: {
    min: 50,
    max: 75
  },
  l: {
    min: 60,
    max: 80
  }
};

/**
 *  Generic
 */
const RX_ARRAY_NOTATION = /\[(\d+)]/g;
const RX_BV_PREFIX = /^(BV?)/;
const RX_DIGITS = /^\d+$/;
const RX_EXTENSION = /^\..+/;
const RX_HASH = /^#/;
const RX_HASH_ID = /^#[A-Za-z]+[\w\-:.]*$/;
const RX_HTML_TAGS = /(<([^>]+)>)/gi;
const RX_HYPHENATE = /\B([A-Z])/g;
const RX_LOWER_UPPER = /([a-z])([A-Z])/g;
const RX_NUMBER = /^[0-9]*\.?[0-9]+$/;
const RX_PLUS = /\+/g;
const RX_REGEXP_REPLACE = /[-/\\^$*+?.()|[\]{}]/g;
const RX_SPACES = /[\s\uFEFF\xA0]+/g;
const RX_SPACE_SPLIT = /\s+/;
const RX_STAR = /\/\*$/;
const RX_START_SPACE_WORD = /(\s|^)(\w)/g;
const RX_TRIM_LEFT = /^\s+/;
const RX_TRIM_RIGHT = /\s+$/;
const RX_UNDERSCORE = /_/g;
const RX_UN_KEBAB = /-(\w)/g;
const RX_ABBREVIATION_FROM_STRING = /[\p{Alpha}\p{Nd}]+/gu;
/**
 *  Date
 */
// Loose YYYY-MM-DD matching, ignores any appended time inforation
// Matches '1999-12-20', '1999-1-1', '1999-01-20T22:51:49.118Z', '1999-01-02 13:00:00'
const RX_DATE = /^\d+-\d\d?-\d\d?(?:\s|T|$)/;
// Used to split off the date parts of the YYYY-MM-DD string
const RX_DATE_SPLIT = /-|\s|T/;
// Time string RegEx (optional seconds)
const RX_TIME = /^([0-1]?[0-9]|2[0-3]):[0-5]?[0-9](:[0-5]?[0-9])?$/;
/**
 *  URL
 */
// HREFs must end with a hash followed by at least one non-hash character
const RX_HREF = /^.*(#[^#]+)$/;
const RX_ENCODED_COMMA = /%2C/g;
const RX_ENCODE_REVERSE = /[!'()*]/g;
const RX_QUERY_START = /^(\?|#|&)/;
/**
 *  Color
 */
const RX_SHORT_COLOR = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
const RX_LONG_COLOR = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;

function getHashOfString(str) {
  return Math.abs(str.split('').reduce((hash, char) => char.charCodeAt(0) + ((hash << 5) - hash), 0));
}
function normalize(hash, min, max) {
  return Math.floor(hash % (max - min) + min);
}

function hexToRgb(hex) {
  hex = hex.replace(RX_SHORT_COLOR, (m, r, g, b) => r + r + g + g + b + b);
  const result = RX_LONG_COLOR.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}
function componentToHex(c) {
  const hex = c.toString(16);
  return hex.length == 1 ? '0' + hex : hex;
}
function rgbToHex(r, g, b) {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
}
function generateHslFromString(str, limits = HSL_LIMITS) {
  const hRange = (limits === null || limits === void 0 ? void 0 : limits.h) ? [limits.h.min, limits.h.max] : [0, 360];
  const sRange = (limits === null || limits === void 0 ? void 0 : limits.s) ? [limits.s.min, limits.s.max] : [0, 100];
  const lRange = (limits === null || limits === void 0 ? void 0 : limits.l) ? [limits.l.min, limits.l.max] : [0, 100];
  const hash = getHashOfString(str);
  const h = normalize(hash, ...hRange);
  const s = normalize(hash, ...sRange);
  const l = normalize(hash, ...lRange);
  return {
    h,
    s,
    l
  };
}
function hslToColorString(hsl) {
  return `hsl(${hsl.h}, ${hsl.s}%, ${hsl.l}%)`;
}
function generateColorFromString(str, limits = HSL_LIMITS) {
  return hslToColorString(generateHslFromString(str, limits));
}

export { RX_QUERY_START as A, RX_SHORT_COLOR as B, RX_LONG_COLOR as C, hexToRgb as D, rgbToHex as E, generateHslFromString as F, hslToColorString as G, HSL_LIMITS as H, generateColorFromString as I, getHashOfString as J, normalize as K, RX_ARRAY_NOTATION as R, RX_BV_PREFIX as a, RX_DIGITS as b, RX_EXTENSION as c, RX_HASH as d, RX_HASH_ID as e, RX_HTML_TAGS as f, RX_HYPHENATE as g, RX_LOWER_UPPER as h, RX_NUMBER as i, RX_PLUS as j, RX_REGEXP_REPLACE as k, RX_SPACES as l, RX_SPACE_SPLIT as m, RX_STAR as n, RX_START_SPACE_WORD as o, RX_TRIM_LEFT as p, RX_TRIM_RIGHT as q, RX_UNDERSCORE as r, RX_UN_KEBAB as s, RX_ABBREVIATION_FROM_STRING as t, RX_DATE as u, RX_DATE_SPLIT as v, RX_TIME as w, RX_HREF as x, RX_ENCODED_COMMA as y, RX_ENCODE_REVERSE as z };
